module.exports = __webpack_public_path__ + "static/paradise-poster-fd97a5d29f53cfe9dc3739f95a59c354.jpg";